import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function Animations() {
	animations()
}

//
// Define your functions here
//
function animations() {

	gsap.registerPlugin(ScrollTrigger);

	addClasses();

	animateFormLabel();

	shakeOnHover();

	// Grab the prefers reduced media query
	const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

	if (mediaQuery && !mediaQuery.matches) { //if they have no preference/haven not chosen to reduce motion
		runAnimations();
	}

}

function animateFormLabel() {

	var elements = document.querySelectorAll('input[type=text],textarea')
	for (var i = 0; i < elements.length; i++) {

		elements[i].addEventListener('focus', function () {
			var id = this.id;
			var label = document.querySelector('label[for="' + id + '"]');

			if (label) {
				label.classList.add("label-onfocus");
			}
		});

		elements[i].addEventListener('blur', function () {
			var id = this.id;
			var label = document.querySelector('label[for="' + id + '"]');

			if (label) {
				if (this && this.value) {
					label.classList.add("label-onfocus");
				}
				else {
					label.classList.remove("label-onfocus");
				}
			}


		});

		elements[i].addEventListener('keyup', function (e) {
			var id = this.id;
			var label = document.querySelector('label[for="' + id + '"]');

			if (label) {
				label.classList.add("label-onfocus");

				if (this && this.value) {
					label.classList.add("label-onfocus");
				}
				else {
					label.classList.remove("label-onfocus");
				}
			}
		});
	}
}


function addClasses() {
	const header = document.querySelectorAll('header');
	const main = document.querySelectorAll('main');
	const footer = document.querySelectorAll('footer');

	gsap.to(header, {
		scrollTrigger: {
			trigger: main,
			endTrigger: footer,
			start: 1,
			end: "bottom top",
			toggleClass: { targets: header, className: "scrolling" },
			toggleActions: 'play none none none'
		}
	});


	//apply class is-active to all sections when they are in viewport
	const sections = document.querySelectorAll('section');

	sections.forEach((section) => {
		gsap.to(section, {
			scrollTrigger: {
				trigger: section,
				start: 'top +=10%',
				end: () => `+=${section.clientHeight + 30}`,
				toggleActions: 'play reverse none reverse',
				toggleClass: { targets: section, className: "is-active" }
			}
		});

	});

	ScrollTrigger.batch(".swipeUp:not(.tns-slide-cloned)", {
		onEnter: elements => {
				gsap.from(elements, {
				autoAlpha: 0,
				y: 60,
				stagger: 0.15,
				scrollTrigger: {
					trigger: elements,
					start: 'top bottom'
				},
			});
		},
		once: true
	});
}

function runAnimations() {
	// fade In section
	const sectionsFadeUp = document.querySelectorAll('.fadeUp');

	sectionsFadeUp.forEach((section) => {

		section.style.opacity = 0;

		gsap.to(section, {
			opacity: 1,
			scrollTrigger: {
				trigger: section,
				start: 'top bottom-=200',
				toggleActions: 'play none none reverse'
			}
		});

	});

}

const randomInRange = (min, max) => Math.random() * (max - min) + min

function shakeOnHover() {
	const slideShakeWrapperElement = document.querySelectorAll('.slide-shake-wrapper');

	slideShakeWrapperElement.forEach(item => {
		item.addEventListener('mouseenter', () => {
			const tl = gsap.timeline({ repeat: 0 });
			let step = 0;

			tl.to(item, {
				duration: 0.35,
				scale: 1.1,
				opacity: 0.8,
				filter: "blur(1px)",
				ease: "power1.inOut",
				onUpdate: function() {
					setTimeout(() => {
						const range = 1.15*step;
						gsap.to(item, {
							duration: 0.01,
							x: () => randomInRange(-range, range),
							y: () => randomInRange(-range, range),
							ease: "none"
						});
						step++
					}, 25)
				}
			}).to(item, {
				duration: 0.35,
				scale: 1,
				opacity: 1,
				filter: "blur(0)",
				ease: "power1.inOut",
				onUpdate: function() {
					const range = Math.ceil(1.15*step);
					gsap.to(item, {
						duration: 0.01,
						x: () => randomInRange(-range, range),
						y: () => randomInRange(-range, range),
						ease: "none"
					});
					step--
					if(step < 0) step = 0
				},
				onComplete: function() {
					setTimeout(() => {
						gsap.to(item, {
							duration: 0,
							x: 0,
							y: 0,
							ease: "none"
						});
					}, 100)
				}
			})
		})
	})
}

